import { handleUpdateProjectResource } from '@/service/projectService';
import { uploadFileToS3 } from '@/service/s3Service';
import Utils from '@/common/utils/utils';
import { getAllProjectListInCorporation } from '@/service/projectService';
import Constant from '@/common/constant/Constant';
import { Storage } from 'aws-amplify';
import Logger from '@/common/utils/Logger';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

export const isExistProjectAlias = (projectListInCorp, projectId, projectAlias) => {
    let projectByAlias = projectListInCorp.filter(
        project => project.projectAlias?.toLowerCase() === projectAlias.toLowerCase()
    );

    if (Utils.isEmptyArray(projectByAlias)) return false;

    if (projectByAlias?.length === 1 && projectByAlias[0]?.id === projectId) return false;

    return true;
};

export const validateHeader = value => {
    if (value.length > 20000) return 'COMMSG037';

    return '';
};

export const validateFooter = value => {
    if (value.length > 20000) return 'COMMSG037';

    return '';
};

export const validateProjectAlias = value => {
    if (value.length > 120) return 'COMMSG037';

    return '';
};

export const onFocusOutProjectAlias = (value, errors, setErrors, setIsEnableEditUrl) => {
    if(Utils.isEmptyString(value)) {
        let errorsClone = { ...errors };
        errorsClone.projectAlias = 'COMMSG014';
        setErrors(errorsClone);
    } else {
        setIsEnableEditUrl(false);
    }
}

export const getError = (errors, fieldName) => {
    if (Utils.isEmptyObject(errors)) return null;

    return errors[fieldName];
};

export const getValue = (data, fieldName) => {
    if (Utils.isEmptyObject(data)) return null;

    return data[fieldName];
};

export const generateURL = (organizationDomain, projectAlias) => {
    if (Utils.isEmptyString(organizationDomain) || Utils.isEmptyString(projectAlias)) return '';

    return `${window.location.origin}/${organizationDomain}/${projectAlias}/kb`;
};

export const onCopyURL = (organizationDomain, projectAlias) => {
    let url = generateURL(organizationDomain, projectAlias);
    if (Utils.isEmptyString(url)) return;

    navigator.clipboard.writeText(url);
};

export const isDisableBtnSubmit = (isChangeData, errors, isActiveUrl) => {
    // no data change
    if (!isChangeData) return true;

    // data changed but some errors occur
    if (!Utils.isEmptyObject(errors) && isActiveUrl) return true;

    return false;
};

export const onClickBtnSave = async (
    API,
    corporationDetail,
    projectDetail,
    settingData,
    croppedImage,
    errors,
    setErrors,
    enqueueSnackbar,
    setIsLoading,
    setIsOpenConfirmSave,
    setReloadPage,
    userId,
    setIsShowUploadError
) => {
    if (settingData.isActiveUrl) {
        // Case switch ON Url
        await onSubmitSetting(
            API,
            corporationDetail,
            projectDetail,
            settingData,
            croppedImage,
            errors,
            setErrors,
            setIsLoading,
            setReloadPage,
            enqueueSnackbar,
            userId,
            setIsShowUploadError
        );
    } else {
        // Case switch OFF Url
        setIsOpenConfirmSave(true);
    }
};

export const onSubmitSetting = async (
    API,
    corporationDetail,
    projectDetail,
    settingData,
    croppedImage,
    errors,
    setErrors,
    setIsLoading,
    setReloadPage,
    enqueueSnackbar,
    userId,
    setIsShowUploadError
) => {
    try {
        setIsLoading(true);
        let listProjectInCorp = await getAllProjectListInCorporation(
            API,
            projectDetail.affiliationOrganization,
            Constant.ACTIVE_FLAG.ACTIVE
        );

        if (Utils.isEmptyArray(listProjectInCorp)) {
            setIsLoading(false);
            return;
        }

        if (isExistProjectAlias(listProjectInCorp, projectDetail.id, settingData.projectAlias)) {
            let errorsClone = { ...errors };
            errorsClone.projectAlias = 'PLKNOWMSG003';
            setErrors(errorsClone);
            setIsLoading(false);
            return;
        }

        let hasUploadError = false;

        // Upload CSS
        let newVersion = settingData.versionPublicKnowledgeStyleCss + 1;
        let cssVersion = settingData.versionPublicKnowledgeStyleCss;

        let newFileKey = Utils.genKeyFileCss(corporationDetail.id, projectDetail.id, newVersion);
        let currentFileKey = Utils.genKeyFileCss(corporationDetail.id, projectDetail.id, settingData.versionPublicKnowledgeStyleCss);
        try {
            await uploadCssFileToS3(newFileKey, settingData.styleSheet);
            cssVersion = newVersion;
            await Storage.remove(currentFileKey).catch(error => {
                Logger.error('Error deleting old CSS file:', error);
            });
        } catch (cssUploadError) {
            Logger.error('PublicKnowledgeSiteSettingHandler - upload CSS failed, keep current version: ', cssUploadError);
            hasUploadError = true;
        }

        let updateSettingData = {
            isActiveUrl: true,
            isShowKnowledgeList: settingData.isShowKnowledgeList,
            isShowChatbot: settingData.isShowChatbot,
            isShowIframe: settingData.isShowIframe,
            header: settingData.header,
            footer: settingData.footer,
            gaScript: settingData.gaScript,
            logo: settingData.logo,
            versionPublicKnowledgeStyleCss: cssVersion,
            isEnableSearchSynonym: settingData.isEnableSearchSynonym

        };

        // Upload logo
        if (croppedImage) {
            let fileExtension = croppedImage?.name?.split('.').pop() || '';
            if (!fileExtension) {
                setIsLoading(false);
                return;
            }
            let newLogoPath = `${corporationDetail?.organizationDomain}/${
                projectDetail.id
            }/public_knowledge/logo/${Date.now().toString()}.${fileExtension}`;
            try {
                await uploadLogoS3(croppedImage, newLogoPath);
                updateSettingData.logo = newLogoPath;
            } catch (logoUploadError) {
                Logger.error('PublicKnowledgeSiteSettingHandler - upload logo failed, keep current logo: ', logoUploadError);
                hasUploadError = true;
            }
        }

        let updateProjectData = {
            publicKnowledgeSiteSetting: updateSettingData,
            projectAlias: settingData.projectAlias
        };

        const updateSettingParams = {
            publicKnowledgeSiteSetting: JSON.stringify(updateProjectData),
            method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.SETTING_PUBLIC_KNOWLEDGE_SITE,
            corporationId: projectDetail.affiliationOrganization,
            projectId: projectDetail.id,
            userId
        }

        await handleUpdateProjectResource(API, updateSettingParams);

        setIsLoading(false);

        if (hasUploadError) {
            setIsShowUploadError(true);
        } else {
            setReloadPage(Date.now().toString());
            enqueueSnackbar(buildSnackbarMessage('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }
    } catch (error) {
        Logger.error('PublicKnowledgeSiteSettingHandler.js :>> error :>>', error);
    }
};

const uploadLogoS3 = async (croppedImage, filePath) => {
    if (croppedImage && croppedImage.file) {
        let fileUpload = { ...croppedImage };
        fileUpload.key = filePath;

        let uploadAvatar = await uploadFileToS3(filePath, fileUpload, {
            acl: "public-read",
            level: 'public'
        });
        if (!uploadAvatar) {
            throw new Error('Logo file upload failed');
        }

        // Verify file is uploaded successfully
        let getFileResult = await Storage.get(filePath, {
            download: true,
            cacheControl: 'no-cache'
        });

        if (!getFileResult) {
            throw new Error('Logo file upload verification failed');
        }
    }
};

export const uploadCssFileToS3 = async (fileKey, fileContent) => {
    const file = new Blob([fileContent], { type: 'text/css' });
    await Storage.put(fileKey, file, {
        acl: 'public-read',
        level: 'public',
        contentType: file.type
    });
    
    // Verify file is publicly accessible after upload
    let getFileResult = await Storage.get(fileKey, {
        download: true,
        cacheControl: 'no-cache'
    });

    if (!getFileResult) {
        throw new Error('CSS file upload verification failed');
    }
};

export const saveInActiveUrl = async (
    API,
    projectDetail,
    settingData,
    setIsLoading,
    setReloadPage,
    enqueueSnackbar,
    userId
) => {
    try {
        let currentSettingData = Utils.convertJSONDataToObject(
            projectDetail.publicKnowledgeSiteSetting
        );
        if (!Utils.isEmptyObject(currentSettingData)) {
            setIsLoading(true);
            let updateSettingData = { ...currentSettingData };
            updateSettingData.isActiveUrl = false;

            let updateProjectData = {
                publicKnowledgeSiteSetting: updateSettingData,
                projectAlias: settingData.projectAlias
            };
            
            const updateSettingParams = {
                publicKnowledgeSiteSetting: JSON.stringify(updateProjectData),
                method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.SETTING_PUBLIC_KNOWLEDGE_SITE,
                corporationId: projectDetail.affiliationOrganization,
                projectId: projectDetail.id,
                userId
            }
            await handleUpdateProjectResource(API, updateSettingParams);

            setIsLoading(false);
        }

        setReloadPage(Date.now().toString());
        enqueueSnackbar(buildSnackbarMessage('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } catch (error) {
        console.log('PublicKnowledgeSiteSettingHandler :>> saveInActiveUrl ~ error :>> ', error);
    }
};
